// eslint-disable-next-line @guusje4525/mui-import-checker
import { SxProps, Theme } from '@mui/material';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react-lite';
import { useThemeStore } from 'theme/ThemeStore';
import { useTheme } from 'theme/useTheme';

type XeroAuthButtonProps = {
   onClick: () => any,
   sx?: SxProps<Theme>,
}

export default observer(function XeroAuthButton(props: XeroAuthButtonProps) {
   const theme = useTheme()
   const themeStore = useThemeStore()

   const baseTheme: SxProps<Theme> = {
      ...(props.sx || {}),
      lineHeight: '28px',
      fontWeight: 'bold',
      paddingY: '6px',
      paddingX: '2rem',
      border: '1px solid transparent',
   }

   const buttonTheme: Record<'light' | 'dark', SxProps<Theme>> = {
      dark: {
         ...baseTheme,
         color: '#ffffff',
         backgroundColor: '#003c64',
         borderColor: '#003c64',
         '&:hover': {
            backgroundColor: '#002a46',
            borderColor: '#002a46',
         },
      },
      light: {
         ...baseTheme,
         color: theme.palette.gap.primary['800'],
         backgroundColor: '#ffffff',
         background: 'none',
         borderColor: theme.palette.gap.primary['800'],
      }
   }

   return (
      <Button
         variant={themeStore.dark ? 'contained' : undefined}
         size="large"
         sx={buttonTheme[themeStore.themeMode]}
         startIcon={
            <img src="/images/icons/xero-logo.svg" width="26" />
         }
         onClick={props.onClick}
      >
         Continue with Xero
      </Button>
   )
})
